import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from '@tanstack/react-router'
import { Button } from 'ui/button'

export const Error = (props: { error: Error }) => {
  const { t } = useTranslation()

  useEffect(() => {
    console.error({ message: 'Error boundary caught an error', error: props.error })
  }, [props.error])

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 px-4" role="alert">
      <h3 className="text-lg">{t('Something went wrong')}</h3>
      <p>
        {t('We apologize for the inconvenience')} <br />
        {t('You can use report the issue to help us improve the application')}{' '}
        <Link className="text-blue-600 underline" to="/settings/contact-us">
          {t('report')}
        </Link>
      </p>
      <Button onClick={() => window.location.reload()}>{t('Refresh the page')}</Button>
    </div>
  )
}
